import styled from "styled-components";
import { Card } from "react-bootstrap";
import CreateOutlinedIcon from '@material-ui/icons/CreateOutlined';

export const Item = styled(Card)`
  width: 90%;
  height: auto;
  background-color: #ffffff;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  padding: 0.5rem;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  border: 0.5px solid #c9c9c9;
  margin: 0.7rem 1rem;

  @media (min-width: 500px) {
    margin: 0.7rem auto;
  }
`;

export const ItemTitle = styled.h1`
  font-size: 13px;
  color: #000FFF;
  font-size: ${(props) => props.fontSize};
  font-weight: ${(props) => (props.weight ? props.weight : `550`)};

  p {
    margin-bottom: 0;
    width: 100%;
    color: black;
  }

  @media (min-width: 768px) {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 0;
  }
`;

export const Status = styled.div`
  margin-bottom: 0.2rem;
  margin-top: -0.3rem;
  color: #000FFF;
  font-weight: 550;
`;

export const ImgDetails = styled.img`
  margin: 0 0 0.15rem 0.2rem;

  @media (max-width: 500px) {
    margin: 0px 0.1rem 0.1rem 0.2rem;
  }
`;

export const ItemDetails = styled.span`
  color: #808080;
  font-size: 11px;
  font-weight: 300;
  margin: ${(props) => props.margin};

  @media (max-width: 500px) {
    font-size: 10px;
    margin: ${(props) => props.margin500};
  }

  @media (min-width: 768px) {
    display: flex;
    justify-content: flex-end;
    margin: ${(props) => props.margin};

    ${Status} {
      margin-top: 0rem;
      margin-left: 1.5rem;
      margin-right: 0.5rem;
    }
  }
`;

export const Details = styled.span`
  background-color: #000FFF;
  position: relative;
  top: 0.1rem;
  right: -0.5rem;
  color: white;
  padding: 0.15rem 1rem;
  border-bottom-left-radius: 0.8rem;
  border-top-left-radius: 0.8rem;

  @media (max-width: 500px) {
    right: -0.4rem;
    padding: 0.2rem 0 0.2rem 0.4rem;
  }

  @media (min-width: 768px) {
    font-size: 0.6rem !important;
    padding: 0.15rem 0.2rem;
    ${ImgDetails} {
      width: 18%;
    }
  }

  @media (min-width: 800px) {
    font-size: 0.6rem;
    padding: 0.15rem 0.4rem;
    ${ImgDetails} {
      width: 18%;
    }
  }

  @media (min-width: 850px) {
    font-size: 0.7rem !important;
    padding: 0.15rem 0.5rem;
    ${ImgDetails} {
      width: 18%;
    }
  }

  @media (min-width: 900px) {
    font-size: 0.7rem !important;
    padding: 0.15rem 0.8rem;
    ${ImgDetails} {
      width: 18%;
    }
  }
`;

export const StatusCollor = styled.div`
  width: 0.7rem;
  height: 0.7rem;
  border-radius: 2rem;
  margin: 0.2rem 0.3rem 0 0;
  background-color: ${(props) => {
    if (
      props.status === "AGUARDANDO ANÁLISE DO FINANCEIRO" ||
      props.status === "EM ANÁLISE PELO FINANCEIRO" ||
      props.status ===
        "AGUARDANDO APROVAÇÃO DA LOGÍSTICA PARA INCLUSÃO NA PROGRAMAÇÃO" ||
      props.status ===
        "AGUARDANDO APROVAÇÃO DO CONSULTOR COMERCIAL PARA INCLUSÃO NA PROGRAMAÇÃO"
    ) {
      return `#000FFF`;
    } else if (props.status === "LIBERADO") {
      return `#00E309`;
    } else if (props.status === "NÃO LIBERADO PELO FINANCEIRO") {
      return `#F7D100`;
    } else {
      return `#FD0000`;
    }
  }};
`;


export const ItemStatusResponsive = styled.div`
  @media (max-width: 767px) {
    display: grid;
    grid-template-columns: 75% 25%;
    width: 100%;
  }

  @media (min-width: 768px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

export const ItemDesktop = styled(Item)`
  padding: 1rem 0.5rem 1rem 1rem;

  ${Details} {
    font-size: 0.7rem;
  }
`;

export const DivisionItems = styled.div`
  @media (max-width: 768px) {
    ${Item} {
      display: flex;
    }
    ${ItemDesktop} {
      display: none;
    }
  }

  @media (min-width: 768px) {
    ${Item} {
      display: none;
    }
    ${ItemDesktop} {
      display: flex;
    }
  }
`;

export const ItemRight = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 70%;
`;

export const ContentTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const ContentStatus = styled.div`
  display: flex;
`;

export const ItemDetailsRight = {
  display: 'flex',
  justifyContent: 'flex-end',
  height: 'fit-content'
};

export const DivisionEdit = styled.div`
  color: #A7A7A7;
  margin: 0 -30% 0 0;
  font-size: .8rem;
  display: flex;
  align-items: center;

  ${CreateOutlinedIcon} {
    width: .7em;
    margin: 0 .3rem .3rem .3rem;

    @media(max-width: 768px) {
      margin: .7rem .3rem .3rem 1rem;
    }
  }
`;
